/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fundName: NonNullable<unknown> }} Cas_Confirmation_Turn_OnInputs */

const en_cas_confirmation_turn_on = /** @type {(inputs: Cas_Confirmation_Turn_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By turning on CAS statements, ${i?.fundName} will start to offer a Capital Account (Excel) export to its investors`)
};

/**
* | output |
* | --- |
* | "By turning on CAS statements, {fundName} will start to offer a Capital Account (Excel) export to its investors" |
*
* @param {Cas_Confirmation_Turn_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_confirmation_turn_on = /** @type {((inputs: Cas_Confirmation_Turn_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Confirmation_Turn_OnInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_confirmation_turn_on(inputs)
});